import { Radio } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const RadioWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 30px;
`;

export const StyledRadio = styled(Radio)`
    width: fit-content !important;
`;
